module.exports = __webpack_public_path__ + "static/sehyuk_yim-467ab878fb0b4b05bace82f2b9a3e24e.jpg";